import SushiMascot from '../assets/images/logo.png'
import CateringMascot from '../assets/images/panda-catering-logo-no-bg.png'
import { AppType } from './appType'

export const BRANDS: Record<
  AppType,
  { mascot: string; first: string; second: string; fallbackImage: string }
> = {
  sushi: {
    mascot: SushiMascot,
    first: 'Panda',
    second: 'Sushi',
    fallbackImage: '/logo_bg.png',
  },
  catering: {
    mascot: CateringMascot,
    first: 'Panda',
    second: 'Catering',
    fallbackImage: '/panda-catering-logo-bamboo.png',
  },
}

export function handleImageFallback(appType: AppType) {
  // React's onError stays attached and a leftover srcset keeps winning over src,
  // so without the guard a broken image retries forever.
  return ({ currentTarget }: React.SyntheticEvent<HTMLImageElement>) => {
    if (currentTarget.dataset.fallback) return
    currentTarget.dataset.fallback = 'true'
    currentTarget.removeAttribute('srcset')
    currentTarget.removeAttribute('sizes')
    currentTarget.src = BRANDS[appType].fallbackImage
  }
}
